import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

// Attach JWT token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('brazyy_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 — token expired
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('brazyy_token');
      localStorage.removeItem('brazyy_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const authAPI = {
  getLoginUrl: () => `${API_URL}/api/auth/discord`,
  getMe: () => api.get('/api/auth/me'),
};

// Guilds
export const guildsAPI = {
  getAll: () => api.get('/api/guilds/mine'),
  getOne: (guildId) => api.get(`/api/guilds/${guildId}`),
  update: (guildId, data) => api.patch(`/api/guilds/${guildId}`, data),
  getRanks: (guildId) => api.get(`/api/guilds/${guildId}/ranks`),
  createRank: (guildId, data) => api.post(`/api/guilds/${guildId}/ranks`, data),
  updateRank: (guildId, rankId, data) => api.patch(`/api/guilds/${guildId}/ranks/${rankId}`, data),
  deleteRank: (guildId, rankId) => api.delete(`/api/guilds/${guildId}/ranks/${rankId}`),
};

// Staff
export const staffAPI = {
  getAll: (guildId) => api.get(`/api/staff/${guildId}`),
  getOne: (guildId, discordId) => api.get(`/api/staff/${guildId}/${discordId}`),
  update: (guildId, discordId, data) => api.patch(`/api/staff/${guildId}/${discordId}`, data),
};

// Shifts
export const shiftsAPI = {
  getAll: (guildId, params) => api.get(`/api/shifts/${guildId}`, { params }),
};

// Adjustments
export const adjustmentsAPI = {
  getAll: (guildId, params) => api.get(`/api/adjustments/${guildId}`, { params }),
};

// Logs
export const logsAPI = {
  getAll: (guildId, params) => api.get(`/api/logs/${guildId}`, { params }),
};

export default api;
